<template>
  <div class="component footer">
    <div class="footer__top">
      <span v-if="$store.state.lang === 'en'">
        * This legal note is to alert you in case you didn’t get it that the apartments are not really for free , and no, you will not get a free luxury apartment when you buy a t-shirt at that price. You are actually paying for it. To be totally honest is probably more the opposite: you buy an apartment and you’ll get a t-shirt for free. Prices may vary . Additional fees apply, including title and transfer fees and taxes. T-shirts designed by Diesel. Qualified buyers only. Except as required by law, all terms and conditions of sale are within the sole discretion of Bel Invest which is solely responsible for sale t-shirts and apartments subject to limited availability. Diesel Wynwood condominium is sold by Bel Invest under exclusive license from Diesel.
      </span>
      <span v-if="$store.state.lang === 'es'">
        * Mediante este aviso legal les informamos en el caso de que no lo estuvieran que estos apartamentos no son realmente gratuitos. Y no, no van a conseguir hacerse con un apartamento de lujo de forma gratuita comprando una camiseta a este precio. De hecho, lo que realmente paga es el precio del apartamento. Para serles sinceros, realmente sea lo opuesto: al comprar un apartamento, se llevan una camiseta de regalo. Los precios pueden variar. Se aplicarán tarifas adicionales, incluyendo las tasas e impuestos de título de propiedad, transferencia de este y impuestos adicionales. Camisetas diseñadas por Diesel. Exclusivo para compradores cualificados. Excepto en lo requerido por la ley, los términos y condiciones de venta quedan a la discreción exclusiva de Bel Invest, única responsable de la comercialización y venta de camisetas y apartamentos sujetos a disponibilidad limitada. La comercialización y venta de Diesel Wynwood Condominium será realizada por parte de Bel Invest bajo licencia exclusiva de Diesel.
      </span>
    </div>
    <footer>
      <div class="footer__logo">
        <img src="/static/vector/diesel.svg" alt="Diesel Wynwood" v-if="$store.state.mode === 'clothes'">
        <img src="/static/vector/diesel_light.svg" alt="Diesel Wynwood" v-if="$store.state.mode === 'estate'">
      </div>
      <div class="footer__contacts">
        <div class="footer__contacts-wrapper" data-medusa-animation="slide">
          <div>148NW 28th, Miami,<br >FL 33127, United States</div>
          <div><a href="mailto:info@dieselwynwood.com">info@dieselwynwood.com</a></div>
        </div>
        <div class="footer__contacts-wrapper" data-medusa-animation="slide">
          <div><a href="tel:+1 305 440 4610">+1 305 440 4610</a></div>
        </div>
      </div>
      <div class="footer__developed" data-medusa-animation="slide">
        <div>Diesel Wynwood Condominium is sold by Bel Invest under Exclusive License from Diesel</div>
      </div>
      <div class="footer__copy" data-medusa-animation="slide">
        <div v-if="$store.state.lang === 'en'"><span><a href="https://www.iubenda.com/privacy-policy/13526818" target="_blank">Privacy</a> . <a href="https://www.iubenda.com/privacy-policy/13526818/cookie-policy" target="_blank">Cookies</a></span><span class="copy">©2019</span></div>
        <div v-if="$store.state.lang === 'es'"><span><a href="https://www.iubenda.com/privacy-policy/57022479" target="_blank">Privacidad</a> . <a href="https://www.iubenda.com/privacy-policy/57022479/cookie-policy" target="_blank">Cookies</a></span><span class="copy">©2019</span></div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterBlock',
};
</script>

<style lang="scss">
.footer {
  padding: $vertical-padding $horizontal-padding;
  font-size: rem(27);
  font-size: calc(27 * var(--rw));
  line-height: rem(48px);
  line-height: calc(48px * var(--rw));

  @include mq($until: ipadL) {
    padding: $mobile-vertical-padding $mobile-horizontal-padding;
  }

  &__top {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: calc((100vh / 18) * 2);
  }

  footer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    @include mq($until: ipadL) {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    > div {
      margin: 20px 0px;
    }
  }

  &__contacts-wrapper,
  &__developed,
  &__copy {
    overflow: hidden;
  }

  &__developed {
    max-width: 20%;

    @include mq($until: ipadP) {
      max-width: 100%;
    }

    a {
      text-decoration: underline;
    }
  }

  &__logo {
    width: calc(240px * var(--rw));
  }

  &__copy {
    span.copy {
      display: inline-block;
      margin-left: 40px;
    }
  }
}
</style>
